import axios from 'axios'

import { BASE_URL, SUBSCRIBE_URL, CLIENT_CODE } from '@/constants'
import store from '@/stores'

export const client_code = CLIENT_CODE

export const PUBLIC_KEY =
	'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGffmeii8i6xjKMlXBj+fNFenVF12RNTX/lTxYtMXZQJQpAZLZfGD0J137ITKiQdcYWEYLIU9O8uQQkFNXmbIDSuMBA5+jxrowjPlwup6Zdb8buUX+tb9eHzODr5Q9HyTPSNjbFru9ZF9wDRxR0Nz9MADOowfPqhTYcSmlK2CFE7AgMBAAE='

export const api = axios.create({
	baseURL: BASE_URL
})

export const subscribe = axios.create({
	baseURL: SUBSCRIBE_URL
})

export const setHeaderAuth = (jwt: string): void => {
	api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
	api.interceptors.response.use(
		response => {
			return response
		},
		error => {
			if (error?.response?.status === 401) {
				store.dispatch.auth.loggedOut(() => console.log('Logout: Unautorized'))
			}
			return Promise.reject(error)
		}
	)
}

export const setHeaderSubscribe = (jwt: string): void => {
	subscribe.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
	subscribe.interceptors.response.use(
		response => {
			return response
		},
		error => {
			if (error?.response?.status === 401) {
				store.dispatch.auth.loggedOut(() => console.log('Logout: Unautorized'))
			}
			return Promise.reject(error)
		}
	)
}
